var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.currentDialog,{tag:"component",attrs:{"message":_vm.message,"title":_vm.title},on:{"cancel":_vm.handleCancel,"ok":_vm.handleConfirm},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}})
}
var staticRenderFns = []

export { render, staticRenderFns }